import * as yup from 'yup';

export const riderPaymentSchema = yup
	.object({
		rider: yup
			.string()
			.required('Debes seleccionar un operador'),
		partner: yup
			.string(),
		method: yup.string().required('Debes seleccionar un método de pago'),
		amount: yup.number().required('Debes ingresar el monto a pagar'),
		details: yup.string().optional(),
		type: yup.string().required('Debes seleccionar el tipo de pago'),
	})
	.required();
